import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RatioOptions } from '@df/ui/atomic/atomic-options';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { defaultImage } from 'projects/app-default/src/app/icms.config';

export namespace NCmsBlogImageCopy {
    export const componentId = 'blog-image-copy';

    export interface IComponentData extends NICmsContentComponent.IData {
        reverse: boolean;
        firstSection: string;
        firstImage: string;
        ratio?: string;
        firstCaption: string;
        secondSection: string;
        variant: 'image' | 'text';
        secondImage: string;
        secondCaption: string;
        title: string;
        copy: string;
        buttonCopy: string;
        buttonUrl: string;
    }
}

@ICmsComponent<CmsBlogComponentImageCopyComponent>({
    id: NCmsBlogImageCopy.componentId,
    name: 'Blog Image/Copy',
    tags: ['Blog', 'Image', 'Copy'],
    isAdvanced: true,
    onDemandOnly: true,
    fields: [
        {
            key: 'reverse',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Reverse'
        },
        <NICmsContentField.IChoiceField>{
            key: 'ratio',
            type: NICmsContentField.EFieldType.choice,
            title: 'Ratio',
            options: RatioOptions,
            default: 'ratio-1-1'
        },
        {
            key: 'firstSection',
            type: NICmsContentField.EFieldType.label,
            title: 'First section'
        },
        {
            key: 'firstImage',
            type: NICmsContentField.EFieldType.image,
            title: 'First image',
            required: true,
            default: defaultImage
        },
        {
            key: 'firstCaption',
            title: 'First caption',
            type: NICmsContentField.EFieldType.text,
            required: true,
            default: 'Image caption'
        },
        {
            key: 'secondSection',
            type: NICmsContentField.EFieldType.label,
            title: 'Second section'
        },
        <NICmsContentField.IChoiceField>{
            key: 'variant',
            type: NICmsContentField.EFieldType.choice,
            title: 'Variant',
            options: [
                { key: 'image', title: 'Image' },
                { key: 'text', title: 'Text' }
            ],
            default: 'text'
        },
        {
            key: 'secondImage',
            type: NICmsContentField.EFieldType.image,
            title: 'Second image',
            required: true,
            default: defaultImage,
            canShow: (data: NCmsBlogImageCopy.IComponentData) => data.variant === 'image'
        },
        {
            key: 'secondCaption',
            title: 'Second caption',
            type: NICmsContentField.EFieldType.text,
            required: true,
            default: 'Image caption',
            canShow: (data: NCmsBlogImageCopy.IComponentData) => data.variant === 'image'
        },
        {
            key: 'title',
            title: 'Title',
            required: true,
            default: 'Lorem ipsum dolor sit amet',
            type: NICmsContentField.EFieldType.text
        },
        {
            key: 'copy',
            title: 'Copy',
            required: true,
            default: 'Lorem ipsum dolor sit amet consectetur adipiscing elit.',
            type: NICmsContentField.EFieldType.text
        },
        {
            key: 'buttonCopy',
            title: 'Button copy',
            required: true,
            default: 'Lorem ipsum',
            type: NICmsContentField.EFieldType.text
        },
        {
            key: 'buttonUrl',
            title: 'Button URL',
            required: true,
            default: '/',
            type: NICmsContentField.EFieldType.text
        }
    ],
    priority: 20
})
@Component({
    selector: 'cms-blog-component-image-copy',
    templateUrl: './cms-blog-component-image-copy.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CmsBlogComponentImageCopyComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component?: NCmsBlogImageCopy.IComponentData;
}
